<template>
  <Grid align-content="start" gap="var(--r-space-sm)" class="address-fields">
    <RInput v-model="address.address_1" label="Address 1" no-hint no-feedback-icon></RInput>
    <RInput v-model="address.address_2" label="Address 2" no-hint no-feedback-icon></RInput>
    <RInput v-model="address.post_code" label="Postcode" no-hint no-feedback-icon></RInput>
    <RInput v-model="address.city" label="City" no-hint no-feedback-icon></RInput>
    <RInput v-model="address.state" label="State" no-hint no-feedback-icon></RInput>
    <RDropdown
      v-model="address.country"
      :options="settings.options.countries"
      map-options
      emit-value
      label="Country"
      no-hint
    />
  </Grid>
</template>

<script>
export default {
  props: {
    initialAddress: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      address: {
        address_1: this.initialAddress.address_1 || null,
        address_2: this.initialAddress.address_2 || null,
        post_code: this.initialAddress.post_code || null,
        city: this.initialAddress.city || null,
        state: this.initialAddress.state || null,
        country: this.initialAddress.country || null,
        use_address_type: this.initialAddress.use_address_type || null,
        address_type: this.initialAddress.address_type || null
      }
    }
  },

  computed: {},

  methods: {
    //Access from parent
    getPayload() {
      return this.address
    }
  }
}
</script>
